module.exports = __webpack_public_path__ + "static/me-03d9475ac591d426552d525923cff3db.png";